export * as FoundationFixture from './foundation'
export * as ServiceOfferFixture from './service-offer'
export * as ConsultationFixture from './consultation'
export * as HospitalFixture from './hospital'
export * as OrganicADFixture from './organic-ad'
export * as HospitalChatFixture from './hospital-chat'
export * as MemberFixture from './member'
export * as PerformanceFixture from './performance'
export * as PerformanceAdFixture from './performance-ad'
export * as PointFixture from './point'
export * as PaymentFixture from './payment'
export * as ReservationFixture from './reservation'
export * as TreatmentFixture from './treatment'
export * as DoctorFixture from './doctor'
export * as CommunityFixture from './community'
export * as ReviewFixture from './review'
export * as AppointmentFixture from './appointment'
export * as PurchaseFixture from './purchase'
export * as DistrictFixture from './district'
export * as LucybotFixture from './lucybot'
export * as DisplayFixture from './display'
export * as CouponFixture from './coupon'
